import React from 'react';
import { ALL_COLORS } from '../config';

class ColoPicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            selectedColor: null
        }
    }
    colorPicked(color){
        this.props.onChange(color);
    }
    render() { 
        return ( 
            <div>
                {ALL_COLORS.map((color, i) => (
                    <div key={"color" + i} onClick={()=>this.colorPicked(color)} 
                    className={"kwizda-colorpicker-color kwizda-pickcolor-" + color.replace("#","")}
                        style={{
                        backgroundColor:color}}>
                            {(this.props.value === color)?
                                <img src="img/icon-check.png" alt="választott szín"/>:
                                ""
                            }
                    </div>
                ))}
            </div>
         );
    }
}
 
export default ColoPicker;